import { Icon } from '@iconify/react'
import { Button, Tooltip } from 'antd'
import React from 'react'

import { AuctionMonitoringRecord } from '../../common/auctionMonitoringTypes'
import { AUCTION_STATES } from '../../common/auctionScrapeTypes'
import { UserActivityLog } from '../../graphql/generated'
import { AuctionMonitoringLinkedPropertyModalButton } from '../components/AuctionMonitoringLinkedPropertyModalButton/AuctionMonitoringLinkedPropertyModalButton'
import { Min } from '../components/DateFormat/DateFormat'
import { Money } from '../components/Money/Money'
import { UserActivityLogBadge } from '../components/UserActivityLogBadge/UserActivityLogBadge'

export const renderStartDate = (startDate: string) =>
  startDate ? <Min>{startDate}</Min> : null

export const renderEndDate = (endDate: string) =>
  endDate ? <Min>{endDate}</Min> : <span className="text-gray-400">---</span>

export const renderPrice = (price: number) =>
  price > 0 ? (
    <Money grayscale amount={price} decimalNumbers={0} symbol="Kč" />
  ) : (
    <span className="text-gray-400">---</span>
  )
export const createLinkedPropertiesRenderer = (
  record: AuctionMonitoringRecord,
  handleExpandRow: (id: string) => void,
  title: string
) => {
  return record?.linkedProperties?.totalCount ? (
    <Button
      type="link"
      size="small"
      className="!pl-0"
      onClick={() => handleExpandRow(record.id)}
    >
      {title}
    </Button>
  ) : (
    <AuctionMonitoringLinkedPropertyModalButton
      auctionId={record?.id}
      propertyCount={record?.linkedProperties?.totalCount}
    />
  )
}

export const renderAuctionedOn = (
  auctionedOn: string,
  record: AuctionMonitoringRecord
) => (
  <a
    className="flex items-center space-x-1"
    href={record.detailUrl}
    target="_blank"
    rel="noreferrer"
    title="Zobrazit detail dražby v novém okně"
  >
    <Icon icon="quill:link-out" className="-mb-0.5" width="12" height="12" />
    <span>{auctionedOn}</span>
  </a>
)

export const renderAuctionDecreeUrl = (auctionDecreeUrl: string) =>
  auctionDecreeUrl ? (
    <a
      href={auctionDecreeUrl}
      target="_blank"
      rel="noreferrer"
      title="Zobrazit dražební vyhlášku v novém okně"
    >
      <Icon
        icon="pepicons-pencil:file"
        className="-mb-0.5"
        width="16"
        height="16"
      />
    </a>
  ) : (
    <span title="Dražební vyhláška není k dispozici" className="text-gray-400">
      ---
    </span>
  )

export const renderState = (state: string) => {
  const isUpcoming = state === AUCTION_STATES.UPCOMING
  const circleColor = isUpcoming
    ? 'border-green-300 bg-lime-200'
    : 'border-red-300 bg-red-200 '
  const label = isUpcoming ? 'Připravovaná' : 'Ukončená'

  return (
    <Tooltip title={label} className="p-1">
      <span
        className={`inline-block h-2.5 w-2.5 rounded-full border ${circleColor}`}
      />
    </Tooltip>
  )
}

export const renderInfo = (_: string, record: AuctionMonitoringRecord) => (
  <UserActivityLogBadge
    userActivityLog={record.activityLogs?.nodes?.[0] as UserActivityLog}
    alertDateTo={(record.updatedAt as string) || (record.createdAt as string)}
  />
)

export const auctionDecreeColumnTitle = (
  <Tooltip title="Dražební vyhláška">
    {/* div is needed for tooltip to work */}
    <div>
      <Icon
        icon="pepicons-pencil:file"
        className="-mb-0.5"
        width="16"
        height="16"
      />
    </div>
  </Tooltip>
)
